import { useEffect, useState } from "react";

export const useWidthSize = () => {
    const [widthSize, setWidthSize] = useState();
    const [observingWidth, setObservingWidth] = useState(true);

    useEffect(() => {
        if (observingWidth) {
            const divRoot = document.getElementById("root");
            const resizeObserver = new ResizeObserver(entries => {
                for (const entry of entries) {
                    if (entry?.contentRect?.width) {
                        console.log("content height resize observer", entry?.contentRect?.width);
                        setWidthSize(entry?.contentRect?.width);
                    }
                }
            });
            setObservingWidth(false);
            resizeObserver.observe(divRoot);
        }
    }, [observingWidth]);

    return { widthSize };
};
